import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import TextBoxWithTooltip from 'components/shared/textBoxWithTooltip';
import { COVERAGE_STATUS } from 'constants/succession';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    borderBottom: `1px solid ${primary.blue12}`,
    paddingBottom: spacing(8),
    marginBottom: spacing(6),
  },
  info: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gridColumnGap: 32,
    gridRowGap: 60,
  },
  label: {
    color: primary.bluish3,
    lineHeight: '20px',
    marginBottom: spacing(2),
  },
}));

const KeyJobInfo = ({ translations, keyJob }) => {
  const classes = useStyles();

  const items = [
    {
      label: translations.type,
      value: translations?.types?.[keyJob?.job_type] || '-',
    },
    {
      label: translations.family,
      value: keyJob?.job_family?.name || '-',
    },
    {
      label: translations.criticality,
      value: keyJob.criticality?.label || '-',
    },
    {
      label: translations.coverageLabel,
      value: translations?.coverage?.[COVERAGE_STATUS[keyJob?.coverage]] || '-',
    },
  ];

  const renderLabel = label => (
    <Typography className={classes.label} variant="body2">
      {label}
    </Typography>
  );

  const renderItem = ({ label, value }) => (
    <div key={label}>
      {renderLabel(label)}
      <TextBoxWithTooltip variant="subtitle1" text={value} />
    </div>
  );

  return (
    <div className={classes.root}>
      <div className={classes.info}>{items.map(renderItem)}</div>
    </div>
  );
};

KeyJobInfo.propTypes = {
  translations: PropTypes.object.isRequired,
  keyJob: PropTypes.object.isRequired,
};

export default KeyJobInfo;
